import { render, staticRenderFns } from "./expertsManage.vue?vue&type=template&id=be017802&"
import script from "./expertsManage.vue?vue&type=script&lang=js&"
export * from "./expertsManage.vue?vue&type=script&lang=js&"
import style0 from "./expertsManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports